import React from 'react';
import Modal from 'react-responsive-modal';
import ReactTable from "react-table";
import Translate from 'translate';
import moment from 'moment';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
class ActivityModal extends React.Component {

  customFormaDate( key, value) {
    const {externalCustomer, dateFormat} = this.props;
    if (key.indexOf('date') !== -1 || key.indexOf('Date') !== -1 ) {
      if (externalCustomer === 'apu') {
        return moment(value, "YYYY-MM-DD" ).format( dateFormat );
      } else {
        return moment.unix( value ).format( dateFormat ); 
      }
    } else {
      return value
    }
  } 
  render() {
    const { data, onClose, open, dateFormat } = this.props;
    const key = _.keys( data )[0];
    const formattedData = key ? data[key] || [] : [];

    return (
      <Modal little
             modalClassName="col-md-8 max-width-unset client-folder p-0"
             open={open}
             onClose={onClose}>
        <div className="p-3 mb-4 bg-blue">
          <h5 className="m-0 d-inline-block">
            {key ? <Translate id={key}/> : ''}
          </h5>
        </div>

        <div className="row mb-5 px-3">
          <div className="col-md-12">
            <ReactTable className="app-table -highlight app-table-white"
                        data={formattedData}
                        pageSize={formattedData ? formattedData.length : 0}
                        resizable={false}
                        sortable={false}
                        showPaginationBottom={false}
                        showPaginationTop={false}
                        columns={formattedData && formattedData.length
                          ? _.map( _.keys( formattedData[0] ), ( key ) => ( {
                            Header: <Translate id={key}/>,
                            accessor: key,
                            Cell: props =>  this.customFormaDate(key, props.value) ,
                          } ) ) : []}
            />
          </div>
        </div>
      </Modal>
    )
  }
}
const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCustomer: state.settings.externalCustomer,
} );
export default injectIntl( connect( mapStateToProps )( ActivityModal ) );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/ActivityModal/index.js